// extracted by mini-css-extract-plugin
export default {"carousel_container":"MediaRecommendations_carousel_container__bM4r2","section_card":"MediaRecommendations_section_card__UmdDP"};